import React from 'react'
type HeaderProps = {
    title: string,
    subtext: string,
}
function Header({title, subtext}: HeaderProps) {
  return (
    <div>
        <p className='page-title'>{title}</p>
        <p className='page-subtitle'>{subtext}</p>
    </div>
  )
}

export default Header